"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.AppProviders = void 0;

var _react = _interopRequireDefault(require("react"));

var _breadcrumbContext = require("./breadcrumb-context");

var _optionsContext = require("./options-context");

var _jsxFileName = "/home/circleci/project/src/components/app-providers.js";

var AppProviders = function AppProviders(_ref) {
  var element = _ref.element,
      pluginOptions = _ref.pluginOptions;
  var defaultCrumb = pluginOptions.defaultCrumb,
      useClassNames = pluginOptions.useClassNames,
      useAutoGen = pluginOptions.useAutoGen,
      usePathPrefix = pluginOptions.usePathPrefix;
  return _react.default.createElement(_optionsContext.OptionsProvider, {
    useAutoGen: useAutoGen || false,
    useClassNames: useClassNames || false,
    usePathPrefix: usePathPrefix || null,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 17
    },
    __self: this
  }, _react.default.createElement(_breadcrumbContext.BreadcrumbProvider, {
    defaultCrumb: defaultCrumb || null,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 22
    },
    __self: this
  }, element));
};

exports.AppProviders = AppProviders;